(function () {
  function handleClick(e) {
    var btn = e.target.closest('.js-ns-bundle');
    if (!btn) return;

    var mattId = btn.getAttribute('data-matt-id');
    var transId = btn.getAttribute('data-trans-id');
    var mattAvail = btn.getAttribute('data-matt-available') === 'true';
    var transAvail = btn.getAttribute('data-trans-available') === 'true';

    if (!mattId || !transId) return;
    if (!mattAvail || !transAvail) {
      alert('Eine der Varianten ist aktuell nicht verfügbar.');
      return;
    }

    btn.disabled = true;
    var oldText = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(mattId), quantity: 1 },
          { id: Number(transId), quantity: 1 }
        ]
      }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function () {
      // Sofort mit Rabattcode weiterleiten
      window.location.href = '/discount/BUNDLE20?redirect=/cart';
    })
    .catch(function () {
      alert('Upsell konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      btn.disabled = false;
      btn.textContent = oldText;
    });
  }

  // Delegation – funktioniert auch, wenn der Block per AJAX neu gerendert wird
  document.addEventListener('click', handleClick);
})();
